import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as CheckIcon } from '@material-design-icons/svg/round/check.svg'
import { ReactComponent as CopyIcon } from '@material-design-icons/svg/round/content_copy.svg'
import { ReactComponent as SyncIcon } from '@material-design-icons/svg/round/sync.svg'
import Button from 'components/common/Button'
import IconButton from 'components/common/IconButton'
import ImageSlider from 'components/ImageSlider'
import BottomControls from 'components/BottomControls'
import SaveButton from 'components/SaveButton'
import useCopy from 'hooks/useCopy'
import { BaseAsset } from 'types/Response'
import c from './FinishStage.module.scss'

interface FinishStageProps {
  text: string
  currentAssetUrl: string | undefined
  assets: BaseAsset[]
  onCurrentAssetIndexChange: (newCurrentAssetIndex: number) => void
  onGenerateMore: () => void
}

function FinishStage({
  text,
  currentAssetUrl,
  assets,
  onCurrentAssetIndexChange,
  onGenerateMore,
}: FinishStageProps) {
  const { t } = useTranslation()

  const { isCopied, handleCopy } = useCopy(text)

  const copyIcon = useMemo(() => {
    return isCopied ? (
      <CheckIcon style={{ fill: 'currentColor' }} />
    ) : (
      <CopyIcon style={{ fill: 'currentColor' }} />
    )
  }, [isCopied])

  return (
    <>
      <ImageSlider
        assets={assets}
        onCurrentAssetIndexChange={onCurrentAssetIndexChange}
      />
      <div className="bottom">
        <div className={c.request}>
          <p className={c.requestText}>
            {t('stages.generation.finish.requestHead')}: {text}
          </p>
          <IconButton
            className={c.copyButton}
            disabled={isCopied}
            onClick={handleCopy}
          >
            {copyIcon}
          </IconButton>
        </div>
        <BottomControls className={c.controls}>
          <Button
            className={c.controlsButton}
            startIcon={<SyncIcon style={{ fill: 'currentColor' }} />}
            onClick={onGenerateMore}
          >
            {t('general.buttons.generateMore')}
          </Button>
          <SaveButton className={c.controlsButton} imageUrl={currentAssetUrl} />
        </BottomControls>
      </div>
    </>
  )
}

export default FinishStage
